export const getCommutifiErrorCode = (error: any): string | number | undefined => {
  // Axios error path (error.response.data.code)
  const axiosCode = error?.response?.data?.code;
  if (axiosCode != null) return axiosCode;

  // Nested error structure (error.error.data.code)
  if (Object.prototype.hasOwnProperty.call(error, 'error')) {
    return error.error?.data?.code ?? undefined;
  }

  // Direct data structure (error.data.code)
  if (Object.prototype.hasOwnProperty.call(error, 'data')) {
    return error?.data?.code ?? undefined;
  }

  // Bare CommutifiErrorData (has isCommutifiError flag + direct code)
  if (error?.isCommutifiError && error?.code != null) {
    return error.code;
  }
  return undefined;
};
export const getHttpStatusFromError = (error: any = {}) => error && (error.response?.status || error.status || error.statusCode || error.httpCode);